import React, { forwardRef, useState } from 'react';
import {
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCubes,
  faRefresh,
  faSearch,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Card,
  Loader,
  Modal,
  Select,
  rem,
  Text,
  Button,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../api/EndPoints";
import badge from "../../../assets/badge.png";
import GroupText from "../GroupText";
import ChildrenFilter from "./ChildrenFilter";
import ParentFilter from "./ParentFilter";
import "./SideBarMobile.css";
import B2BButton from "../../common/B2BButton";
import SortDropdown from "../../../SortDropdown";
import { FaLink } from "react-icons/fa";
import BottomCollectionsSB from './BottomCollectionsSB';
import TopCollectionsSB from './TopCollectionsSB';
import { IconArrowLeft } from '@tabler/icons-react';

const SideBarMobile = forwardRef(({
  isTab,
  sideBarFolded,
  onSearchClick,
  collectid,
  mobileModelOpen,
  mobileModelClose,
  mobileModelIsOpen,
  selectedItems,
  vendorIddApp,
  fromAppBody,
  selectedMenu,
  collectionName,
  chipperArray,
  itemCount,
  selectedCollection,
  setSelectedCollection,
  handleChipClear,
  viewProducts,
  loading,
  pimsFromVendorFilter,
  hasMore,
  overAllFilterClearAll,
  setPage,
  handleMenuClick,
  handleMenuOutsideClick,
  checkboxChange,
  checkboxChangeCollection,
  filteredSearch,
  filterHeader,
  filterClearAll,
  handleColorClick,
  handleOnApply,
  fetchProducts,
  setVendorIddApp,
  handleFilterChange,
  group,
  variants,
  setMenuOpened,
  filters,
  sortValue,
  setSortValue,
  profile,
  searchHandle,
  allFilter,
  handlesearch,
  search
}, ref) => {
  const [vendorIdd, setVendorIdd] = useState(vendorIddApp || null);
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [isFiltersVisible, setIsFiltersVisible] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isSample = localStorage.getItem("token") ? false : true;
  const isApproved = profile?.approveStatus === "APPROVED";
  const navigate = useNavigate();

  const closeSecondModal = () => {
    setIsSecondModalOpen(false);
  };
  const foldSideBarWhenOutSideClick = () => {
    if (isTab && !sideBarFolded) {
      onSearchClick(true);
    }
  };

  const toggleFilters = () => {
    setIsFiltersVisible((prev) => !prev);
  };

  const renderColorCode = (productVariants) => {
    if (productVariants && productVariants.length > 0) {
      const hexaColorCodes = productVariants.flatMap((item) =>
        item.variants?.filter((variant) => variant.hexaColorCode)
      );
      return (
        <div
          className={`colorchips ${_.size(hexaColorCodes) < 12 ? "borderable" : ""
            }`}
        >
          {_.map(hexaColorCodes, (hexa, index) => (
            <div
              key={index}
              className="colorchip"
              style={{ backgroundColor: hexa.hexaColorCode }}
            ></div>
          ))}
        </div>
      );
    } else {
      return <></>;
    }
  };
  // nknknnnjnj
  const handleApplyParentFilter = () => {
    mobileModelClose(close);
  };
  const handleApplyChildFilter = () => {
    setIsSecondModalOpen(false);
  };
  const sortOptions = [
    {
      label: "Newest First",
      value: "New false",
    },
    {
      label: "Price (Low - High)",
      value: "Price true",
    },
    {
      label: "Price (High - Low)",
      value: "Price false",
    },
    {
      label: "Weight (Low - High)",
      value: "Weight true",
    },
    {
      label: "Weight (High - Low)",
      value: "Weight false",
    },
    // ,{
    //     label:"MOQ (Low - High)",
    //     value:"MOQ true"
    // },{
    //     label:"MOQ (High - Low)",
    //     value:"MOQ false"
    // }
  ];

  const isNewArrival = (pim) => {
    const createdDate = new Date(pim.createdDate); // assuming createdDate is a valid date string or timestamp
    const currentDate = new Date();
    const diffTime = currentDate - createdDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays <= 5;
  };

  const getTitle = () => {
    if (isSample) {
      return "Please Login to view full product details";
    }
    if (!isApproved) {
      if (!profile.assignedSalesman)
        return "Salesman is not yet assigned to your account. Please contact support";
      else
        return (
          <p>
            Your Account is not approved yet. Please contact your sales
            representative <br />{" "}
            <strong>
              {profile.salesManName} : {profile.salesMan.mobile}
            </strong>{" "}
            for more details
          </p>
        );
    }
  };

  const renderAlert = () => {
    return (
      <>
        <Text size="md" weight={500} style={{ marginBottom: "20px" }}>
          {getTitle()}
        </Text>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {isSample && (
            <B2BButton onClick={() => navigate("/login")} name={"Login"} color={"#8BC53F"} />
          )}
          {!isSample && !isApproved && (
            <B2BButton
              onClick={() => navigate("/profile")}
              style={{ backgroundColor: "#8BC53F" }}
              name={"View Profile"}
            />
          )}
        </div>
      </>
    );
  };

  return (
    <div>
      <div className="right" onClick={foldSideBarWhenOutSideClick}>
        {(isTab || isMobile) && (
          <div
            className={isMobile ? "search-bar sticky" : "search-bar"}
            style={{ cursor: "pointer" }}
          >
            <div className="action-container">
              <div
                className="action"
                onClick={isTab ? () => onSearchClick(false) : mobileModelOpen}
              >
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <div>Search</div>
                {_.size(selectedItems[selectedMenu.category]) > 0 && (
                  <div className="badge-active-children">
                    {_.size(selectedItems[selectedMenu.category])}
                  </div>
                )}
              </div>
              {isMobile && (
                <div className="action filter" onClick={toggleFilters}>
                  <div>
                    Applied filters
                    <FontAwesomeIcon
                      icon={isFiltersVisible ? faChevronUp : faChevronDown}
                    />
                  </div>
                </div>
              )}
            </div>
            {isFiltersVisible && isMobile && _.size(chipperArray) > 0 && (
              <div className="relative">
                <div className="chip-badges line-1">
                  <div
                    className="search-filter-clear-all"
                    onClick={overAllFilterClearAll}
                  >
                    <FontAwesomeIcon icon={faRefresh} />
                  </div>
                  {_.map(chipperArray, (filter, index) => (
                    <div className="active-filter-badge">
                      <div className="label lines-1"> {filter.name} </div>
                      <FontAwesomeIcon
                        icon={faXmark}
                        className="chip-closer"
                        onClick={() => handleChipClear(filter)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        {!isMobile && _.size(chipperArray) > 0 && fromAppBody !== true && (
          <div className="active-filter-values m-b-24">
            <div className="active-filter-badge-container">
              {_.map(chipperArray, (filter, index) => (
                <div
                  className="active-filter-badge-container"
                  key={index}
                  style={{ cursor: "pointer" }}
                >
                  <div className="active-filter-badge">
                    <div className="label lines-1">{filter.name || selectedMenu?.collectionName}</div>
                    <FontAwesomeIcon
                      icon={faXmark}
                      className="chip-closer"
                      onClick={() => handleChipClear(filter)}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="filter-clear-all" onClick={overAllFilterClearAll}>
              <FontAwesomeIcon icon={faRefresh} />
              {!isMobile && <span className="text m-l-8">Clear All</span>}
            </div>
          </div>
        )}
        {/* <Autocomplete
    onOptionSubmit={searchHandle}
    data={allFilter}
    leftSectionPointerEvents="none"
    leftSection={<FontAwesomeIcon icon={faSearch} />}
    placeholder="Search"
    mb={rem(6)}
  /> */}
        {/* <div>  <TopCollectionsSB />  </div> */}
        {collectid && <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", fontWeight: "bold", alignItems: "center", color: "#8BC54F", fontSize: "18px" }}>{collectionName}</div>
          <Button
            color='#8BC54F'
            onClick={() => navigate("/fabrics")}
            leftSection={<IconArrowLeft stroke={2} />}
          >
            Back
          </Button>

        </div>}
        {vendorIddApp && <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", fontWeight: "bold", alignItems: "center", color: "#8BC54F", fontSize: "18px" }}>{pimsFromVendorFilter?.vendorId}</div>
          <Button
            color='#8BC54F'
            onClick={() => {
              setVendorIdd(null);
              setVendorIddApp(null);
              navigate(location.pathname, { replace: true, state: null });
            }}
            leftSection={<IconArrowLeft stroke={2} />}
          >
            Back
          </Button>

        </div>}
        <div className="search-items">

          <br />
          <div className="flex-row items-center flex-between">
            <div
              className="item-total"
              style={{ fontSize: isMobile ? "14px" : "16px" }}
            >
              {itemCount} {itemCount <= 1 ? "Product" : "Products"}
            </div>
            {/* {isSample && (
              <Select
                placeholder="Select sort"
                value={sortValue}
                data={sortOptions}
                required
                onChange={setSortValue}
              />
            )} */}
            <div className="drop-down-filter">
              <input
                onChange={(e) => handlesearch(e.target.value)}
                disabled={isSample}
                value={search}
                placeholder="Search"
                mb={rem(6)}
              />
              <SortDropdown
                value={sortValue}
                disabled={isSample}
                onChange={setSortValue}
                isMobile={isMobile}
              />
            </div>
          </div>

          <InfiniteScroll
            dataLength={viewProducts.length}
            next={() => {
              setPage((prev) => prev + 1);
            }}
            loader={
              loading && (
                <div className="loading-container">
                  <Loader color={"var(--primary)"} type="oval" />
                </div>
              )
            }
            hasMore={hasMore}
            scrollThreshold={0.6}
          >
            <div className="grid">
              {viewProducts?.map((pim, index) => (
                <Card
                  key={index}
                  shadow="sm"
                  padding={0}
                  radius="md"
                  withBorder
                  onClick={() => {

                    !isSample && isApproved
                      ? navigate(pim.landingUrl, { state: {} })
                      : setIsDialogOpen(true);
                  }}
                >
                  {isNewArrival(pim) && (
                    <span className="badge-new-arrival">NEW</span>
                  )}
                  {/* <img
                    className="product-image"
                    src={`${BASE_URL.replace("/api", "")}${pim.image}`}
                    alt="Norway"
                  /> */}
                  <div className="image-wrapper-lib">
                    <img
                      className="product-image-lib"
                      src={`${BASE_URL.replace("/api", "")}${pim.image}?time=${Date?.now()}`}
                      // src={silkimg}
                      alt="Product"
                    />
                    {pim?.bundleId != null && <div className="overlay-text-bundle"> <FaLink style={{ marginTop: "3px", marginRight: "3px" }} /> Matching rib  </div>}

                    {pim?.inSwatchCart && !pim?.inSampleCart && <div className="overlay-text">Added in Swatch Cart</div>}
                    {pim?.inSampleCart && <div className="overlay-text">Added in Sample Cart</div>}
                    <div className="overlay-text-ac">{pim.articleCode}</div>
                  </div>
                  <div style={{ padding: "12px" }}>
                    {renderColorCode(pim.pimVariants)}
                    <div>

                      <div
                        style={{
                          fontWeight: "600",
                          marginBottom: "8px",
                        }}
                      >
                        {pim?.articleName}
                      </div>
                    </div>
                    <div className="quality-price">
                      <b className="price-container">
                        &#8377; {pim.channelPrice}

                      </b>

                    </div>
                    <div className="quality-info">
                      <div className="contents">
                        <div className="f-600 item">
                          <div>{pim.fabricContent?.value}</div>
                        </div>
                      </div>
                    </div>
                    <div style={{ fontSize: "11px" }}>
                      <span className="m-r-0 weight-span">
                        <span>{pim?.metrics?.weight}</span>
                        <span>gsm</span>
                      </span>
                      <span className="m-l-4 m-r-4 weight-span">.</span>
                      <span className='weight-span'>{pim.attributes['Fabric Type']?.name}</span>
                    </div>
                    <div
                      className="badges-quality m-t-8"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="badge-type">
                        <img className="badge-img" src={`${badge}?time=${Date.now()}`} alt="Badge" />
                        {_.size(pim.pimVariants)}
                      </div>
                      <div></div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </InfiniteScroll>
        </div>

        {/* {!hasMore && (<div> <BottomCollectionsSB />  </div>)} */}

        {isSample && !loading && <div className="loginforsample" > <span>Login to view more products ➝</span><br /><span className="login-link" onClick={() => navigate("/login")}>Login</span>
        </div>}
      </div>

      <Modal
        opened={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        size="sm"
        title={"Notification"}
        centered
      >
        {renderAlert()}
      </Modal>
      <Modal
        opened={mobileModelIsOpen}
        onClose={mobileModelClose}
        style={{ marginTop: "0px !important" }}
        title={
          <div style={{ fontWeight: "600", fontSize: "20px" }}>Search</div>
        }
        fullScreen={isMobile}
        transitionProps={{ transition: "fade", duration: 200 }}
      >
        <div
          style={{
            overflowY: "auto",
            height: "calc(100vh - var(--app-shell-header-height))",
          }}
        >
          {Object.keys(group)
            .filter(groupKey => groupKey !== "COLLECTIONS").map((groupKey, index) => (
              <div key={index}>
                <GroupText>{groupKey}</GroupText>
                {group[groupKey].map((cat, subIndex) => (
                  <div
                    key={subIndex}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    {/* {targetChildren(cat)} */}
                    <ParentFilter
                      data={cat}
                      handleMenuClick={handleMenuClick}
                      selectedItems={selectedItems}
                      setIsSecondModalOpen={setIsSecondModalOpen}
                    />
                  </div>
                ))}
              </div>
            ))}
          {isMobile && Object.keys(group)
            .filter(groupKey => groupKey === "COLLECTIONS")
            .map((groupKey, index) => (
              <div key={index}>
                <GroupText>{groupKey}</GroupText>
                <div
                  onClick={() => { handleMenuClick(group[groupKey]); (isMobile && (setIsSecondModalOpen(true))) }}
                  style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "2px" }}>
                  <Text style={{ fontSize: "14px", color: "#000000ff" }} >
                    <FontAwesomeIcon icon={faCubes}
                      style={{ fontSize: "14px", paddingRight: "5px" }}
                    />Collections
                  </Text>
                  <div style={{ display: "flex", alignItems: "center" }}> <FontAwesomeIcon icon={faChevronRight} color="#273344" style={{ fontSize: "12px" }} /></div>
                </div>
              </div>
            ))}
        </div>
        <div className="apply">
          <div className="apply-content" onClick={handleApplyParentFilter}>
            Apply
          </div>
        </div>
      </Modal>
      <Modal
        opened={isSecondModalOpen}
        onClose={() => {
          closeSecondModal();
          handleMenuOutsideClick();
        }}
        fullScreen={isMobile}
        transitionProps={{ transition: "fade", duration: 200 }}
      >
        <ChildrenFilter
          selectedItems={selectedItems}
          selectedMenu={selectedMenu}
          setMenuOpened={setMenuOpened}
          filterClearAll={filterClearAll}
          handleChipClear={handleChipClear}
          handleFilterChange={handleFilterChange}
          selectedCollection={selectedCollection}
          setSelectedCollection={setSelectedCollection}
          handleOnApply={handleOnApply}
          handleColorClick={handleColorClick}
          filteredSearch={filteredSearch}
          variants={variants}
          checkboxChange={checkboxChange}
          checkboxChangeCollection={checkboxChangeCollection}
          filterHeader={filterHeader}
          filters={filters}
        />
        <div className="apply">
          <div className="apply-content" onClick={handleApplyChildFilter}>
            Apply
          </div>

        </div>
      </Modal>

    </div>
  );
});

export default SideBarMobile;
